// src/api/category.api.ts

import { get, post, put, del } from './client';
import {
  ApiResponse,
  Category,
  CreateCategoryDto,
  UpdateCategoryDto,
} from '../types';

export const categoryApi = {
  getAllCategories: () => {
    return get<ApiResponse<Category[]>>('/categories');
  },

  getCategoryById: (id: string) => {
    return get<ApiResponse<Category>>(`/categories/${id}`);
  },

  createCategory: (data: CreateCategoryDto) => {
    return post<ApiResponse<Category>>('/categories', data);
  },

  updateCategory: (id: string, data: UpdateCategoryDto) => {
    return put<ApiResponse<Category>>(`/categories/${id}`, data);
  },

  deleteCategory: (id: string) => {
    return del<ApiResponse>(`/categories/${id}`);
  },
};